var blockquote_default = {
  "fontElementMap": "Jl6vN",
  "quote": "btx8p"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
